import styled from 'styled-components';
import { Typography } from 'antd';

const { Title } = Typography;

const TitleTableColumn = styled(Title)`
  &&& {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
`;
const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-right: 20px;
  input {
    width: 100%;
    text-align: center;
    border: '#0078D4';
    height: 26px;
    font-size: 20px;
    adding: 0;
  }
  button {
    padding: 0 10px !important;
    height: 28px !important;
  }
  p {
    margin-top: 18px;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
  }
  svg {
    font-size: 18px;
  }
`;

export { TitleTableColumn, PaginationWrapper };
